export const DATE_FORMATS = {
  DATE_TIME: 'DD MMM HH:mm',
  FULL_DATE_TIME: 'DD MMM YYYY, HH:mm',
  DATE: 'DD MMM',
  FULL_DATE: 'YYYYMMDD',
  FULL_MONTH_DATE: 'DD MMMM',
  TIME: 'HH:mm'
}
